import { render, staticRenderFns } from "./OpenAccessory.vue?vue&type=template&id=5d087ba7&scoped=true"
import script from "./OpenAccessory.vue?vue&type=script&lang=js"
export * from "./OpenAccessory.vue?vue&type=script&lang=js"
import style0 from "./OpenAccessory.vue?vue&type=style&index=0&id=5d087ba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d087ba7",
  null
  
)

export default component.exports